module.exports = __webpack_public_path__ + "img/exam_jan_2025_2aqsqzhm.6ecdf72f.jpg";